import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pimsService } from '@v2/services';
import type { CreatePimsPayload } from '@v2/types';

interface UseCreatePimsResult {
  createPims: (payload: CreatePimsPayload) => Promise<string>;
  loading: boolean;
  error: string | null;
}

export const useCreatePims = (): UseCreatePimsResult => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: pimsService.createPims,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pims.lists() });
    },
  });

  return {
    createPims: mutation.mutateAsync,
    loading: mutation.isPending,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useCreatePims;
